import * as React from 'react';
import { IconButton } from '@cian/frontend-reviews-components';
import { IconCommunicationComment16, IIconProps } from '@cian/ui-kit-design-tokens/icons';
import { trackAnswersClick } from './tracking';
import { Link } from '../Link';

export interface IReviewAnswersProps {
  reviewId: string;
  fullUrl: string;
  answersCount: number;
}

export const ReviewAnswers: React.FC<IReviewAnswersProps> = ({ reviewId, fullUrl, answersCount }) => {
  return (
    <Link url={`${fullUrl}otzyvy/#${reviewId}`} target="blank" linkStyle={{ display: 'block' }}>
      <IconButton
        Icon={IconCommunicationComment16 as React.ComponentType<IIconProps>}
        label={answersCount}
        onClick={() => trackAnswersClick('')}
      />
    </Link>
  );
};
